/* eslint-disable @typescript-eslint/naming-convention */
import { useQuery } from '@tanstack/react-query';

import { fetchHasFreshNotification } from '../api/notification';
import { useEnvContext } from '../../modules/EnvProvider';

export default function useFetchHasFreshNotification(isFlightMode: boolean) {
  const { targetEnv } = useEnvContext();
  const queryResult = useQuery(
    ['fetchHasFreshNotification'],
    () => fetchHasFreshNotification(targetEnv),
    {
      enabled: !isFlightMode,
    }
  );

  return {
    ...queryResult,
    data: queryResult.data?.data,
  };
}
